//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionPhotoFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 21V3H3V21H21ZM15.25 6.5C16.49 6.5 17.5 7.51 17.5 8.75C17.5 9.99 16.49 11 15.25 11C14.01 11 13 9.99 13 8.75C13 7.51 14.01 6.5 15.25 6.5ZM5 12H9.98L12.5 15H19V19H5V12Z" fill="currentColor" /></svg>;
}
export default IconActionPhotoFill;